function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "pill-oval"
}, React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M451.246,191.633L277.231,45.348l0.873,0.734C321.341,6.84,386.166,3.311,430.052,40.202 c43.885,36.893,51.549,101.361,20.32,150.696"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M266.111,58.576l174.015,146.286l-0.873-0.734c-43.236,39.241-108.062,42.771-151.947,5.88 c-43.885-36.894-51.549-101.362-20.321-150.697"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "pill-round"
}, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M262.963,216.5l-72.913-72.913l0.629-0.629l-0.629,0.629l-0.678-0.678l-0.285,0.285 c-46.391-34.771-110.777-32.532-151.105,7.768C-2.364,191.281-4.63,255.703,30.157,302.123l-0.724,0.724l0.625,0.625l-0.181,0.182 l0.182-0.182l72.965,72.966L262.963,216.5z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M352.439,306.449l0.236-0.236l-0.612-0.612l0.667-0.667l-0.667,0.667l-72.979-72.979L119.146,392.561 l72.925,72.925l-0.144,0.144l0.144-0.144l0.666,0.666l0.768-0.768c46.391,34.782,110.787,32.546,151.12-7.759 C384.976,417.303,387.236,352.87,352.439,306.449z"
}));

var SvgDrugs = function SvgDrugs(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "496px",
    height: "494.043px",
    viewBox: "0 0 496 494.043",
    enableBackground: "new 0 0 496 494.043",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDrugs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drugs.37451823.svg";
export { ForwardRef as ReactComponent };